
import { useState } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { SettingsForm } from "@/components/settings/SettingsForm";
import { SettingsTable } from "@/components/settings/SettingsTable";
import { EmailTester } from "@/components/payment/EmailTester";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Settings = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleSettingUpdated = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-8">
              <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                Settings
              </h1>
              <p className="text-xl text-gray-600 mt-2">
                Configure application settings
              </p>
            </div>
            
            <Tabs defaultValue="general" className="w-full mb-12">
              <TabsList className="mb-6">
                <TabsTrigger value="general">General Settings</TabsTrigger>
                <TabsTrigger value="email">Email Tools</TabsTrigger>
              </TabsList>
              
              <TabsContent value="general" className="space-y-8">
                <SettingsForm onSettingAdded={handleSettingUpdated} />
                <SettingsTable key={refreshTrigger} />
              </TabsContent>
              
              <TabsContent value="email">
                <div className="mb-6">
                  <h2 className="text-2xl font-semibold text-gray-800">Email Testing Tools</h2>
                  <p className="text-gray-600">Test your email configuration by sending test emails</p>
                </div>
                <EmailTester />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Settings;
